<template>
  <div
    class="button"
    @click="$emit('click')"
    v-text="text"
  ></div>
</template>

<script>
export default {
  props: {
    text: { type: String, required: true, },
  },
};
</script>

<style lang="stylus" scoped>
div.button
  color #FFFFFF
  display block
  margin 16px
  background #FF5500
  border-radius 8px
  font-style normal
  font-weight bold
  font-size 17px !important
  height 38px
  line-height 38px
  align-items center
  text-align center
  letter-spacing -0.0241176em
  cursor pointer
</style>